export function normalizeNpsn(value) {
    if (typeof value !== "string") return null;
    const normalized = value.trim().toUpperCase();
    return /^[A-Z0-9]{8}$/.test(normalized) ? normalized : null;
}
